<template>
    <component v-if="layoutComponent" :is="layoutComponent" :key="$route.fullPath">
      <router-view />
    </component>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import NoLayout from '@/layouts/NoLayout.vue'

export default {
  components: { DefaultLayout },

  computed: {
    layoutComponent() {
      if (!this.$route.meta) return null;
      // Ako ruta ima meta.layout === 'none', koristi 'div' (ili možeš napraviti i prazni 'NoLayout')
      return this.$route.meta.layout === 'none' ? NoLayout : DefaultLayout;
    }
  }
}
</script>